export default __webpack_public_path__ + "static/media/packNPlay.3d23d8b7.jpg";